import NavBar from "../components/navbar";
import Footer from "../components/footer";
import dayjs from "dayjs";

import {
  LocationMarkerIcon,
} from "@heroicons/react/solid";

import { SetStateAction, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { threadsInTopicApi } from "../services/thread";
import { Scrollbars } from "react-custom-scrollbars-2";
import Pagination from '../components/shared/Pagination'
import "../components/shared/Pagination.css";
import { AxiosError } from "axios";

export type ThreadList = {
  id: number;
  topicId: number;
  createdBy: string;
  threadsTitle: string;
  createdDate: number;
  lastUpdated: number | null;
};


const Forum = (props: any) => {
  const navigate = useNavigate();
  const { topicId } = useParams();
  const [threads, setThreads] = useState<ThreadList[]>();
  const [currentPage, setCurrentPage] = useState(1)
  let rowsPerPage = 5

  useEffect(() => {
    const loadThreadsInTopic = async () => {
      try {
        const threadsInTopic = await threadsInTopicApi(topicId);
        if (threadsInTopic) {
          setThreads(threadsInTopic.threadsList);
        }
      } catch (e) {
        if (e instanceof AxiosError) {
          navigate("/NotFound");
        }
      }
    };
    loadThreadsInTopic();
  }, []);

  //get current page
  const indexofLastdata = currentPage * rowsPerPage;
  const indexofFirstdata = indexofLastdata - rowsPerPage;
  var currentdata = threads?.slice(indexofFirstdata, indexofLastdata);

  // Change page
  const paginate = (pageNumber: SetStateAction<number>) => setCurrentPage(pageNumber);

  const createThread = () => {
    navigate(`/forum/${topicId}/createthread`);
  };
  return (
    <>
      <NavBar />
      <div className="mt-20">
        <br></br>
        <div className="place-item-start" style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }} >
          <button
            type="button"
            className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
            onClick={createThread}
          >
            Create Thread
          </button>
        </div>
        <Scrollbars autoHeight autoHeightMin={100} autoHeightMax="calc(80vh - 36px - 35px - 75px)">
          <div className="flex flex-wrap">
            <div className="xl:mx-72 h-fit bg-white object-center shadow overflow-hidden sm:rounded-md w-5/6" >
              <ul role="list" className="divide-y divide-gray-200">
                {currentdata &&
                  currentdata.map((thread) => (
                    <li key={thread.id}>
                      <div className="px-4 py-4 sm:px-6">
                        <div className="flex items-center justify-between">
                          <p className="text-sm font-medium text-indigo-600 truncate">
                            <a
                              href={`/forum/${topicId}/${thread.id}`}
                              className="block hover:bg-gray-50"
                            >
                              {thread.threadsTitle}
                            </a>
                          </p>
                        </div>

                        <div className="mt-2 sm:flex sm:justify-between">
                          <div className="sm:flex">
                            <p className="flex items-center text-sm text-gray-500">
                              Started by: {thread.createdBy}
                            </p>
                            <p className="mt-2 flex items-center text-sm text-gray-500 sm:mt-0 sm:ml-6">
                              <LocationMarkerIcon
                                className="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400"
                                aria-hidden="true"
                              />
                              {dayjs
                                .unix(thread.createdDate)
                                .format("DD MMM YYYY,h:mm A")}
                            </p>
                          </div>
                        </div>
                      </div>
                    </li>
                  ))}
              </ul>
            </div>
          </div>
        </Scrollbars>
        <div className="place-item-start" style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }} >
          <Pagination
            postsPerPage={rowsPerPage}
            totalPosts={threads?.length}
            paginate={paginate}
          />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Forum;
